export const TRACK_LOG_PAGE_URL        = 'track_log/page'
export const TRACK_LOG_PAGE_ERROR      = 'TRACK_LOG_PAGE_ERROR'
export const TRACK_LOG_PAGE_LOADING    = 'TRACK_LOG_PAGE_LOADING'
export const TRACK_LOG_PAGE_SUCCESS    = 'TRACK_LOG_PAGE_SUCCESS'

export const TRACK_LOG_VIEW_URL        = 'track_log/view'
export const TRACK_LOG_VIEW_ERROR      = 'TRACK_LOG_VIEW_ERROR'
export const TRACK_LOG_VIEW_LOADING    = 'TRACK_LOG_VIEW_LOADING'
export const TRACK_LOG_VIEW_SUCCESS    = 'TRACK_LOG_VIEW_SUCCESS'